import { APIMode, APISubmode } from '../../../../api/types';

export const isTextBoxVisible = chatState => {

    const CONDITIONS = {
        isChatAgent: chatState.mode === APIMode.CHAT && chatState.submode !== APISubmode.MAX,
        isChatMax: chatState.mode === APIMode.CHAT &&
            chatState.submode === APISubmode.MAX &&
            chatState.agent.available && chatState.inputMask !== 'disableInput'
    };

    return Object.keys(CONDITIONS).map((c) => CONDITIONS[c]).some(c => c);
};
